// JS file for the Contact Us page

// FAQ items logic

document.addEventListener("DOMContentLoaded", function () {
	// Select all <details> elements
	const faqItems = document.querySelectorAll(".faq-item");

	// Function to close all <details> and change their image to 'plus-circle.svg'
	function closeAllDetailsExcept(current) {
		faqItems.forEach((item) => {
			if (item !== current && item.hasAttribute("open")) {
				item.removeAttribute("open");
				let img = item.querySelector("img");
				img.src = "./images/plus-circle.svg";
				item.classList.remove("selected");
			}
		});
	}

	// Iterate over each <summary> element
	faqItems.forEach((item) => {
		let summary = item.querySelector("summary");
		let img = item.querySelector("img");

		// Add a 'click' event listener to the <summary> element
		summary.addEventListener("click", (event) => {
			// If the <details> is not open, close all others and open this one
			if (!item.hasAttribute("open")) {
				event.preventDefault();
				closeAllDetailsExcept(item);
				item.setAttribute("open", "");
				img.src = "./images/minus-circle.svg";
				item.classList.add("selected");
			} else {
				item.setAttribute("open", "");
				let img = item.querySelector("img");
				img.src = "./images/plus-circle.svg";
				item.classList.remove("selected");
			}
		});
	});
});

// Phone number country calling code logic

document.getElementById("countryCode").addEventListener("change", function () {
	document.getElementById("phone-input").placeholder = this.value + " (555) 000-0000";
});
